import { BracketContext } from "../../components/Brackets/Context";
import BracketComp from "../../components/Brackets/ReactBracket";
import React, { ReactElement } from "react";
import Layout from "../../components/Layouts/default";
import { fetchFromContentful } from "../../utils/contentful/api";
import gql from "graphql-tag";
import { NextPageWithLayout } from "../_app";
import { PreviewWrapper } from "../../components/PreviewWrapper/PreviewWrapper";
import SEO from "../../components/Seo/Seo";
import { generateSingleVideoSlug } from "@/utils/contentful/generateSlugs";

const Bracket: NextPageWithLayout<{
  teams: any;
  matches: any;
  preview: boolean;
  bustedTeamIds: Array<string>;
}> = ({ teams, matches, bustedTeamIds, preview }) => {
  return (
    <PreviewWrapper preview={preview}>
      <SEO
        title="Crypto Project of The Year | Coinage Media"
        description="Submit your picks for the 2024 Crypto Project of The Year"
      />
      <BracketContext teams={teams} matches={matches} bustedIds={bustedTeamIds}>
        <BracketComp />
      </BracketContext>
    </PreviewWrapper>
  );
};

Bracket.getLayout = function getLayout(page: ReactElement) {
  return <Layout hideFooterNewsletter>{page}</Layout>;
};

export default Bracket;

export const getServerSideProps = async ({ preview = false }: any) => {
  const query = gql`
    query bracketPage($preview: Boolean) {
      bracketTeamCollection(preview: $preview) {
        items {
          teamName
          teamId
        }
      }
      bracketGameCollection(order: gameId_ASC) {
        items {
          episodeOrArticle {
            ... on VideoArticle {
              urlSlug
              seasonGroup {
                slug
              }
            }
          }
          gameId
          gameTitle
          homeTeamScore
          awayTeamScore
          gameDate
          homeTeam {
            teamName
            teamId
          }
          awayTeam {
            teamId
            teamName
          }
        }
      }
    }
  `;

  const { data, errors } = await fetchFromContentful({
    query,
    preview
  });

  if (errors) {
    console.error(errors);
  }

  type Team = { teamId: string; teamName: string };

  const teams: Array<Team> = data.bracketTeamCollection.items;

  let teamsObject: Record<string, Team> = {};
  teams.forEach(team => (teamsObject[team.teamId] = team));

  console.log(data);

  const matches = data.bracketGameCollection.items.map(
    (item: any, idx: number) => ({
      id: item.gameId,
      teams: [item.homeTeam, item.awayTeam],
      date: item.gameDate,
      homeScore: item.homeTeamScore,
      awayScore: item.awayTeamScore,
      winningTeam: !item.homeTeamScore
        ? null
        : item.homeTeamScore > item.awayTeamScore
        ? item.homeTeam
        : item.awayTeam,
      losingTeam: !item.homeTeamScore
        ? null
        : item.homeTeamScore < item.awayTeamScore
        ? item.homeTeam
        : item.awayTeam,

      url: item.episodeOrArticle
        ? generateSingleVideoSlug(
            item.episodeOrArticle.seasonGroup.slug,
            item.episodeOrArticle.urlSlug
          )
        : null
    })
  );

  const bustedTeamIds = matches
    .map((match: any) => match.losingTeam?.teamId)
    .filter(Boolean);

  return {
    props: { teams: teamsObject, matches, preview, bustedTeamIds }
  };
};
